import { useEffect, useRef, useState } from "react";
import QrScanner from "qr-scanner";
import { Spinner } from "react-bootstrap";

const QRCodeScanner = ({ onScanComanda }) => {
  const scanner = useRef();
  const videoEl = useRef();
  const [qrOn, setQrOn] = useState(true);
  const [qrData, setQrData] = useState(null);
  // A leitura vale uma vez só: o qr-scanner segue decodificando a cada quadro
  // e o onScanSuccess abaixo é a closure do primeiro render (qrData sempre
  // null ali), então o estado não serve de trava.
  const scannedRef = useRef(false);

  // O pai recria o onScanComanda a cada render. Com ele nas dependências do
  // efeito de entrega, um re-render logo depois da leitura (o dispatch da
  // comanda re-renderiza o checkout antes de o passo mudar) chamava o
  // callback de novo e o pedido saía duas vezes.
  const onScanComandaRef = useRef(onScanComanda);
  useEffect(() => {
    onScanComandaRef.current = onScanComanda;
  });

  const onScanFail = (err) => {
    // console.log(err);
  };

  const onScanSuccess = (result) => {
    if (!result.data || scannedRef.current) return;

    scannedRef.current = true;
    scanner.current?.stop();
    setQrData(result.data);
  };

  useEffect(() => {
    if (qrData) {
      onScanComandaRef.current(qrData);
    }
  }, [qrData]);

  useEffect(() => {
    const curVideoEl = videoEl?.current;

    if (curVideoEl && !scanner.current) {
      scanner.current = new QrScanner(curVideoEl, onScanSuccess, {
        onDecodeError: onScanFail,
        preferredCamera: "user", //environment
        highlightScanRegion: true,
        highlightCodeOutline: true,
      });

      scanner?.current
        ?.start()
        .then(() => setQrOn(true))
        .catch((err) => {
          if (err) setQrOn(false);
        });
    }

    return () => {
      scanner?.current?.stop();
    };
  }, []);

  useEffect(() => {
    if (!qrOn)
      alert(
        "Camera is blocked or not accessible. Please allow camera in your browser permissions and Reload.",
      );
  }, [qrOn]);

  if (qrData) {
    return (
      <div className="d-flex justify-content-center mb-5">
        <Spinner animation="border my-5 totem-checkout-spinner" />
      </div>
    );
  }

  return (
    <div id="video-container">
      <video id="qr-video" ref={videoEl}></video>
    </div>
  );
};

export default QRCodeScanner;
